import img from '../../assets/jane-schmidt.jpg';

const Jane = {
  name: 'Jane Schmidt',
  bio: 'CEO of Empower Plant. Jane is also an environmentalist. Okay, so she’s no Greta Thurnberg, but she brings her own mug for take-away coffee and uses public transportation whenever possible.',
  url: 'jane',
  img,
};

export default Jane;
